import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import ReportDemo from './ReportDemo'
import { ThemeProvider } from './theme'
import { PrefsProvider } from './hooks/useUserPref'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

const isDemo = window.location.pathname === '/demo/report'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <PrefsProvider>
        <ThemeProvider>
          {isDemo ? <ReportDemo /> : <App />}
        </ThemeProvider>
      </PrefsProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
